import React from 'react'
import Header from '../inc/Header'
import HotelpinewoodroomBooking from './HotelpinewoodroomBooking'

function Pinewoodpage() {
  return (
    <div>
        <Header/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        
        <HotelpinewoodroomBooking/>
        <br/>
    </div>
  )
}

export default Pinewoodpage